import React from "react";

const MAP = {
  Preventivo:  { bg: "bg-slate-800/90", text: "text-slate-300", border: "border-slate-700", dot: "bg-slate-400" },
  Confermata:  { bg: "bg-sky-950/80",   text: "text-sky-300",   border: "border-sky-800",   dot: "bg-sky-400" },
  Assegnata:   { bg: "bg-purple-950/80",text: "text-purple-300",border: "border-purple-800",dot: "bg-purple-400" },
  "In corso":  { bg: "bg-emerald-950/80",text: "text-emerald-300",border: "border-emerald-700", dot: "bg-emerald-400 animate-pulse" },
  Completata:  { bg: "bg-cyan-950/80",  text: "text-cyan-300",  border: "border-cyan-800",  dot: "bg-cyan-400" },
  Cancellata:  { bg: "bg-rose-950/80",  text: "text-rose-300",  border: "border-rose-800",  dot: "bg-rose-500" },
  "No show":   { bg: "bg-amber-950/80", text: "text-amber-300", border: "border-amber-800", dot: "bg-amber-500" },
  "Da incassare": { bg: "bg-rose-950/80", text: "text-rose-300", border: "border-rose-800", dot: "bg-rose-500" },
  "Parzialmente incassato": { bg: "bg-amber-950/80", text: "text-amber-300", border: "border-amber-800", dot: "bg-amber-500" },
  "Incassato":  { bg: "bg-emerald-950/80", text: "text-emerald-300", border: "border-emerald-700", dot: "bg-emerald-400" },
  Richiesto:   { bg: "bg-slate-800/90", text: "text-slate-300", border: "border-slate-700", dot: "bg-slate-400" },
  Confermato:  { bg: "bg-sky-950/80",   text: "text-sky-300",   border: "border-sky-800",   dot: "bg-sky-400" },
  Assegnato:   { bg: "bg-purple-950/80",text: "text-purple-300",border: "border-purple-800",dot: "bg-purple-400" },
  Completato:  { bg: "bg-emerald-950/80",text: "text-emerald-300",border: "border-emerald-700",dot: "bg-emerald-400" },
  Cancellato:  { bg: "bg-rose-950/80",  text: "text-rose-300",  border: "border-rose-800",  dot: "bg-rose-500" },
  disponibile: { bg: "bg-emerald-950/80",text: "text-emerald-300",border: "border-emerald-700",dot: "bg-emerald-400" },
  occupato:    { bg: "bg-amber-950/80", text: "text-amber-300", border: "border-amber-800", dot: "bg-amber-500" },
  in_servizio: { bg: "bg-amber-950/80", text: "text-amber-300", border: "border-amber-800", dot: "bg-amber-500" },
  non_disponibile: { bg: "bg-rose-950/80", text: "text-rose-300", border: "border-rose-800", dot: "bg-rose-500" },
  manutenzione:{ bg: "bg-orange-950/80",text: "text-orange-300",border: "border-orange-800",dot: "bg-orange-500" },
  ferie:       { bg: "bg-sky-950/80",   text: "text-sky-300",   border: "border-sky-800",   dot: "bg-sky-400" },
  malattia:    { bg: "bg-rose-950/80",  text: "text-rose-300",  border: "border-rose-800",  dot: "bg-rose-500" },
};

export function StatusBadge({ status }) {
  const s = MAP[status] || MAP.Preventivo;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium ${s.bg} ${s.text} ${s.border}`}
    >
      <span className={`inline-block w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {status}
    </span>
  );
}
